import * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import GridItem from '../../grid/GridItem'
import GridContainer from '../../grid/GridContainer'
import { UserContext } from '../../../App'
import { CSVLink } from 'react-csv'
import { getApiUrl } from '../../../api/api'

export default function HeimratCsvExport() {
  const { user } = useContext(UserContext)

  const [tenants, setTenants] = useState([])

  useEffect(() => {
    getApiUrl()
      .get(`/api/tenants/csv`)
      .then(function(response) {
        setTenants(response.data)
      })
      .catch(function(error) {
        console.log(error)
      })
  }, [user.token])

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        {tenants
          ? Object.entries(tenants).map(([key, value]) => (
            <GridContainer key={key}>
              <GridItem xs={12} sm={12} md={4}>
                <div style={{ padding: '20px 50px 0px' }}>
                  <CSVLink
                    data={value}
                    filename={`${key}.csv`}
                    className="MuiButtonBase-root MuiButton-root MuiButton-text makeStyles-button-59 makeStyles-primary-62">
                    {key}
                  </CSVLink>
                </div>
              </GridItem>
            </GridContainer>
          ))
          : []}
      </GridItem>
    </GridContainer>
  )
}
